import Vue from 'vue';
import config from 'common-module/src/config';

Vue.prototype.$config = config;
